import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Selamat datang, ${u.name}!`);
      const dest = { owner: "/admin", admin: "/admin", gudang_china: "/gudang", gudang_jakarta: "/gudang", induk_kedai: "/induk", agent: "/kedai-panel" }[u.role] || "/";
      nav(dest);
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-6 py-12 grain">
      <div className="w-full max-w-md bg-white rounded-3xl border border-stone-200 shadow-sm p-8">
        <div className="w-12 h-12 rounded-xl bg-emerald-600 flex items-center justify-center text-white font-display font-extrabold text-xl mb-5">K</div>
        <h1 className="font-display text-2xl font-bold text-stone-900">Masuk Akun</h1>
        <p className="text-sm text-stone-500 mt-1">Belanja grosir import lebih mudah, bayar Rupiah.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-stone-600">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 w-full border border-stone-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-emerald-400" placeholder="email@contoh.com" />
          </div>
          <div>
            <label className="text-sm font-medium text-stone-600">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 w-full border border-stone-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-emerald-400" placeholder="••••••••" />
          </div>
          <button data-testid="login-submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-xl transition flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="animate-spin" size={18} />}Masuk
          </button>
        </form>
        <p className="text-sm text-stone-500 mt-5 text-center">Belum punya akun? <Link to="/register" className="text-emerald-700 font-semibold">Daftar</Link></p>
      </div>
    </div>
  );
}
